var a = Math.sign || function (a) {
  var n = +a;
  return 0 == n || n != n ? n : n < 0 ? -1 : 1;
};
export { a as m };